
import { Header } from '../../../components/feature/Header';
import { Footer } from '../../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { DestinationsSection } from './components/DestinationsSection';

export default function AfricaPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <DestinationsSection />
      <Footer />
    </div>
  );
}
